var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-overview',{attrs:{"controller":"Child","filter":_vm.Filter,"hide-actions":"","link-controller":"Child/Monitor","link-key":_vm.link.key,"link-table":"","redirect":"","redirect-page":"Children","rights":_vm.Rights,"tab":"children","type":"child","visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }